import baseContainer from './_baseContainer';
import Navbar from '../components/navbar/Navbar';

const mapStateToProps = state => ({
  navItems: state.navigation.navItems,
  queue: state.navigation.queue,
});

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default baseContainer(mapStateToProps, mapDispatchToProps)(Navbar);
